import { render, staticRenderFns } from "./transportationInformationView.vue?vue&type=template&id=295af662&scoped=true"
import script from "./transportationInformationView.vue?vue&type=script&lang=js"
export * from "./transportationInformationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295af662",
  null
  
)

export default component.exports